let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9dRY7")).then(() => parcelRequire('4U3o9'));